var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{class:{ 'scanner-container--driver': _vm.isDriver },attrs:{"id":"ScannerContainer"}},[_c('scanner-in-store')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }